import React, { Component } from "react";
import { Title } from "../Styles";
import { HoverButton  } from "./Styles/Platform.style";
import { TextBox } from "../Shared/FormHelpers";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";

const Button = styled.i`
  color: #0071bc;
  margin-top: 16px;
`;

export default class SkillSetForm extends Component {
  state = {
    skills: [
      {
        skill: "",
        years_experience: "",
        last_used: "",
        profile_id: this.props.profile.id,
      },
    ],
    updatedSkills: new Set(),
    loaded: false,
  };

  componentWillReceiveProps = (nextProps) => {
    const { profile } = nextProps;
    profile &&
      profile.skill_sets &&
      !this.state.loaded &&
      this.setState({
        skills: [...profile.skill_sets, ...this.state.skills],
        loaded: true,
      });
  };

  saveSkillSet = () => {
    const updatedSkills = Array.from(this.state.updatedSkills);
    const skills = this.state.skills
      .filter((_, i) => updatedSkills.includes(i))
      .map((skills) => {
        return {
          years_experience: skills.years_experience,
          last_used: skills.last_used,
          profile_id: this.props.profile.id,
          id: skills.id ? skills.id : undefined,
          skill_attributes: {
            name: skills.skill,
          },
        };
      });
    skills.length && this.props.save(skills);
    updatedSkills.includes(this.state.skills.length - 1) &&
      this.setState({
        skills: this.state.skills.concat({
          skill: "",
          years_Experience: "",
          last_used: "",
          profile_id: this.props.profile.id,
        }),
      });
    this.setState({ updatedSkills: new Set() });
  };

  delete = (_, index) => {
    let newArray = this.state.skills.filter((_, i) => i !== index);
    const skill = this.state.skills.find((_, i) => i === index);
    if (skill.id) this.props.delete(skill.id);
    this.setState({
      skills: newArray,
    });
  };

  handleChange = (event, index) => {
    let { name, value } = event.target;
    let current = this.state.skills;
    current[index] = { ...current[index], [name]: value };
    this.setState({
      skills: current,
      updatedSkills: this.state.updatedSkills.add(index),
    });
  };

  render() {
    return (
      <div>
        <Title>Skills</Title>
        <div className="profile_detail post">
          {this.state.skills.map((skillSet, i) => (
            <Row key={i}>
              <Col lg={5}>
                <TextBox
                  type="text"
                  className="form-control form-control-lg"
                  name="skill"
                  placeholder="Skill"
                  value={skillSet.skill}
                  onChange={(e) => this.handleChange(e, i)}
                  required="required"
                />
              </Col>
              <Col lg={3}>
                <TextBox
                  type="text"
                  className="form-control form-control-lg"
                  name="years_experience"
                  placeholder="Years Experience"
                  value={skillSet.years_experience}
                  onChange={(e) => this.handleChange(e, i)}
                  required="required"
                />
              </Col>
              <Col lg={3}>
                <TextBox
                  type="text"
                  className="form-control form-control-lg"
                  name="last_used"
                  placeholder="Last Used"
                  value={skillSet.last_used}
                  onChange={(e) => this.handleChange(e, i)}
                  required="required"
                />
              </Col>
              {i !== this.state.skills.length - 1 && (
                <Col lg={1}>
                  <Button
                    style={{ cursor: "pointer" }}
                    className="fa fa-trash"
                    onClick={(e) => this.delete(e, i)}
                  ></Button>
                </Col>
              )}
            </Row>
          ))}
        </div>
        <HoverButton
          type="button"
          className="btn btn-primary btn_apply white_bg"
          hoverData="Create profile first before adding your skills"
          hover={!this.props.profile.id}
          onClick={this.saveSkillSet}
          disabled={!this.props.profile.id}
        >
          Add
        </HoverButton>
      </div>
    );
  }
}
